import { t } from 'i18n';

export const validateSignUp = (data) => {
  const errors = {};

  if (!data.email) {
    errors.email = t('validation.emailRequired');
  } else if (!/\S+@\S+\.\S+/.test(data.email)) {
    errors.email = t('validation.emailInvalid');
  } else {
    delete errors.email;
  }

  if (!data.userName) {
    errors.userName = t('validation.usernameRequired');
  } else if (data.userName.length < 3) {
    errors.userName = t('validation.usernameInvalid');
  } else {
    delete errors.userName;
  }

  if (!data.password) {
    errors.password = t('validation.passwordRequired');
  } else if (data.password.length < 6) {
    errors.password = t('validation.passwordWeak');
  } else {
    delete errors.password;
  }

  if (!data.repeatPassword) {
    errors.repeatPassword = t('validation.required');
  } else if (data.repeatPassword !== data.password) {
    errors.repeatPassword = t('validation.passwordsMatch');
  } else {
    delete errors.repeatPassword;
  }
  
  if (!data.isAccepted) {
    errors.isAccepted = t('validation.mustAccept');
  } else {
    delete errors.isAccepted;
  }

  return errors;
};

export const validateSignIn = (data) => {
  const errors = {};

  if (!data.email) {
    errors.email = t('validation.emailRequired');
  } else if (!/\S+@\S+\.\S+/.test(data.email)) {
    errors.email = t('validation.emailInvalid');
  } else {
    delete errors.email;
  }

  if (!data.password) {
    errors.password = t('validation.passwordRequired');
  } else {
    delete errors.password;
  }

  return errors;
};

export const handleFirebaseError = (error) => {
  switch(error) {
    case "auth/email-already-in-use":
      return {message: "e-mail is already linked to an account or is invalid", severity: "error"};
    case "auth/network-request-failed":
      return {message: "check Your Connection!.", severity: "error"};
    case "auth/user-not-found":
      return {message: "user not found!", severity: "error"};
    case "auth/wrong-password":
      return {message: "your password is wrong", severity: "error"};
    case "auth/too-many-requests":
      return {message: "too many requests, try later.", severity: "error"};
    case "regd":
      return {message: "thanks for register.", severity: "success"};
    case "lgsc":
    case "golg":
      return {message: "welcome back...", severity: "success"};
    case "okcheckout":
      return {message: "Thank you for purchase. Please remember your purchase process takes 2-3 days", severity: "success"};
    default:
      return {message: "Something bad happened! try again later...", severity: "error"};
  }
};

export const handleApiError = (error) => {
  if (typeof error === 'string') {
    return {
      severity: "error",
      message: error
    };
  }
  
  if (error?.response?.data?.detail) {
    return {
      severity: "error", 
      message: error.response.data.detail
    };
  }
  
  return {
    severity: "error",
    message: t('validation.unexpected')
  };
};

export const handleApiSuccess = (message) => {
  return {
    severity: "success",
    message: message
  };
};
